import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import usePublicApi from '../../Hooks/usePublicApi';
import Zoom from 'react-medium-image-zoom';
import { Parser } from 'json2csv';
import { saveAs } from 'file-saver';
import 'react-medium-image-zoom/dist/styles.css';
import './LiveQuote.css';

// utilities
import { displayDate } from '../../Utils/dateFormatUtils';
import { displayQuoteNumber } from '../../Utils/displayQuoteNumber';

// npm components
import { Carousel } from 'react-responsive-carousel';

//carbon components
import { Grid, Row, Column, Button, Loading } from 'carbon-components-react';

import { Email20, Phone20, DocumentDownload32, Printer20 } from '@carbon/icons-react';
import ImageModal from './ImageModal';

function LiveQuote(props) {
	//get props
	const { token } = props;
	// get params
	const { id } = useParams();
	//set state
	const [refresh, setRefresh] = useState(false);
	const [expired, setExpired] = useState(false);
	const [printingMode, setPrintingMode] = useState(false);
	const [showImageModal, setShowImageModal] = useState(false);
	const [modalImages, setModalImages] = useState([]);
	// fetch the inventory data
	const apiPath = `/quotes/${id}`;

	const { error, loading, data, fetchData } = usePublicApi(apiPath);

	useEffect(() => {
		if (data) {
			const expDate = new Date(data.quote.quote.expiration);
			const today = new Date();
			// console.log("comparing", expDate, 'with', today); //debug
			// console.log(expDate < today);
			if (expDate < today) {
				console.log('QUOTE EXPIRED');
				// As per latest requirements, we are not expiring the quotes -- tanishq
				setExpired(false);
			}
		}
	}, [data]);

	const showImageModalAndSetImages = (upc) => {
		setShowImageModal(true);
		setModalImages(images[upc]);
	};

	// FUNCTIONS
	//renders the images
	const renderProductImages = (upc) => {
		// console.log('>>>>>>', images[upc]);
		let imgGallery = images[upc].map((imgLink, i) => {
			return (
				<div
					key={i}
					className={'productImgDesc'}
					style={{ backgroundColor: 'white', backgroundImage: `url(https://cwc-product-images-s3-bucket.s3.amazonaws.com/${imgLink.Key})` }}
				/>
			);
		});

		return imgGallery;
	};

	const _handleDownloadCSVProducts = () => {
		//set file name then save into csv
		const fileName = `CWC_Quote_${displayQuoteNumber(data.quote.quote.quoteNumber)}_${new Date().toString().substr(0, 15)}.csv`.replace(/ /g, '-');
		const theQuoteItems = data.quote.quote.items;

		console.log(theQuoteItems);

		let renamedQuoteItems = theQuoteItems.map((item, i) => {
			let modifiedItem = {};
			Object.keys(item).map((key) => {
				if (key === 'upc') {
					modifiedItem['UPC'] = item[key];
				}
				if (key === 'description') {
					modifiedItem['Description'] = item[key];
				}
				if (key === 'itemNumber') {
					modifiedItem['Item Number'] = item[key];
				}
				if (key === 'packSize') {
					modifiedItem['Case Pack'] = item[key];
				}
				if (key === 'casePerPallet') {
					modifiedItem['Case Per Pallet'] = item[key] ? item[key] : 0;
				}
				if (key === 'units') {
					modifiedItem['Units Available'] = item[key];
				}
				if (key === 'expiration') {
					modifiedItem['Expiration Date'] = item[key];
				}
				if (key === 'listPrice') {
					modifiedItem['Price'] = item[key];
				}
				if (key === 'estimatedShipDate') {
					modifiedItem['Estimated Ship Date'] = item[key];
				}
			});

			return modifiedItem;
		});

		console.log(renamedQuoteItems);

		//UPC, Description, Item Number, Case Pack, Case Per Pallet, Units Available, Expiration Date, Price, Estimated Ship Date

		const fields = [
			'UPC',
			'Description',
			'Item Number',
			'Case Pack',
			'Case Per Pallet',
			'Units Available',
			'Expiration Date',
			'Price',
			'Estimated Ship Date',
		];
		const json2csvParser = new Parser({ fields });
		const csvFile = json2csvParser.parse(renamedQuoteItems);

		var csvblob = new Blob([csvFile], { type: 'text/csv;charset=utf-8' });
		saveAs(csvblob, fileName);
	};

	const _handlePrintPage = () => {
		const headerz = document.getElementsByClassName('bx--header')[0];
		headerz.style.display = 'none';
		setPrintingMode(true);
		console.log(data);
		document.title = `CWC_Quote_${displayQuoteNumber(data.quote.quote.quoteNumber)}_${new Date().toString().substr(0, 15)}.csv`.replace(/ /g, '-');

		setTimeout(() => {
			window.print();
			document.title = 'CWC Web Platform';
			headerz.style.display = 'flex';
			setPrintingMode(false);
			console.log('ok2');
		}, 300);

		// window.print()
		//
		// headerz.style.display = 'flex';
		// setPrintingMode(false)
		// console.log("ok2");
	};

	const [showModal, setShowModal] = useState(false);

	// renders the item cards
	const renderItemCards = () => {
		let itemsJsx = quote.items.map((item, i) => {
			console.log(item);
			return (
				<div key={i} className={printingMode ? 'itemCardContainer marginBottomForPrint' : 'itemCardContainer'}>
					<div onClick={() => showImageModalAndSetImages(item.upc)}>
						<Carousel renderIndicator={false} className={'imgTopPart'}>
							{renderProductImages(item.upc)}
						</Carousel>
					</div>
					<div className={'bottomInfoPart'}>
						<h4>{item.description}</h4>
						<p>
							<strong>UPC:</strong> {item.upc}
						</p>
						<p>
							<strong>Item Number:</strong> {item.itemNumber ? item.itemNumber : 'N/A'}
						</p>
						<p>
							<strong>Cases / Pallet:</strong> {item.casePerPallet ? item.casePerPallet : 'N/A'}
						</p>
						<p>
							<strong>Est Ship Date:</strong> {item.estimatedShipDate}
						</p>
						<p>
							<strong>Expiration Date:</strong> {item.expireDate === '' || !item.expireDate ? 'N/A' : item.expireDate}
						</p>
						<p>
							<strong>Case Pack:</strong> {item.packSize}
						</p>
						<p>
							<strong>Units:</strong> {item.units}
						</p>
						<p>
							<strong>Price:</strong> {item.listPrice}
						</p>
					</div>
				</div>
			);
		});

		return (
			<div id="itemsContainerWrapper">
				<div id="itemsContainer">{itemsJsx}</div>
			</div>
		);
	};

	// condtional renderings

	if (error) {
		console.error(error);
		return (
			<div>
				<p>An error has occurred, please refresh the page</p>
			</div>
		);
	}

	if (loading) {
		return (
			<div id="liveQuoteLoadingContainer">
				<Loading active={true} id="liveQuoteLoading" withOverlay={false} />
			</div>
		);
	}

	if (expired) {
		return (
			<div id="liveQuoteLoadingContainer">
				<p>This quote has expired.</p>
			</div>
		);
	}

	const { quote, images } = data.quote;

	// if (showImageModal) {
	// 	return (
	// 		<div>
	// 			<ImageModal setShowImageModal={setShowImageModal} imageArray={modalImages} />
	// 		</div>
	// 	);
	// }

	return (
		<div id="liveQuoteContainer" className={printingMode ? 'noPaddingForPrint' : ''}>
			<Row id="quoteTopRow" className={printingMode ? 'noWrapForPrint' : ''}>
				<Column lg={9} md={12}>
					<div>
						<div id="salesContact">
							<h4 className={'liveQuoteMiniTitle'}>SALES CONTACT</h4>
							<p>{quote.from.name.toUpperCase()}</p>
							<p>{quote.from.email.toUpperCase()}</p>
							<p>{quote.from.phone.toUpperCase()}</p>
							<p>{'990 Paterson Plank Rd'.toUpperCase()}</p>
							<p>{'East Rutherford, NJ 07073'.toUpperCase()}</p>
						</div>
						<div id="customerContact">
							<h4 className={'liveQuoteMiniTitle'}>CUSTOMER INFORMATION</h4>
							<p>{quote.to.name.toUpperCase()}</p>
							<p>{quote.to.email.toUpperCase()}</p>
							<p>{quote.to.phone.toUpperCase()}</p>
							<p>{quote.to.address1.toUpperCase()}</p>
							<p>{quote.to.address2.toUpperCase()}</p>
						</div>
					</div>
				</Column>
				<Column lg={3} md={12}>
					<div id="quoteInfo">
						<h4>
							<strong>QUOTE #{displayQuoteNumber(quote.quoteNumber)}</strong>
						</h4>
						<p>
							<strong>CREATED:</strong> {displayDate(quote.created_at)}
						</p>
						<p>
							<strong>EXPIRES:</strong> {displayDate(quote.expiration)}
						</p>
						<div id={'quoteActionBtnsContainer'} className={printingMode ? 'hideForPrint' : ''}>
							<Button
								onClick={() => _handlePrintPage()}
								size={'field'}
								className={'quoteActionBtn'}
								renderIcon={Printer20}
								iconDescription={`Print quote`}
								hasIconOnly
							/>
							<a href={`mailto:${quote.from.email}`}>
								<Button
									size={'field'}
									className={'quoteActionBtn'}
									renderIcon={Email20}
									iconDescription={`Email ${quote.from.email}`}
									hasIconOnly
								/>
							</a>
							<a href={`tel:${quote.from.phone}`}>
								<Button
									size={'field'}
									className={'quoteActionBtn'}
									renderIcon={Phone20}
									iconDescription={`Call ${quote.from.phone}`}
									hasIconOnly
								/>
							</a>
						</div>
						<Button
							onClick={() => _handleDownloadCSVProducts()}
							size={'field'}
							// style it to look like a download button for excel
							style={{
								backgroundColor: '#1D6F42',
								color: 'white',
								marginTop: '1rem',
							}}
							className={''}
							renderIcon={DocumentDownload32}
							iconDescription={`Download Quote in Excel Format`}
							hasIconOnly
						>
							Download Quote in Excel Format
						</Button>
					</div>
				</Column>
			</Row>

			{showImageModal && (
				<div>
					<ImageModal setShowImageModal={setShowImageModal} imageArray={modalImages} />
				</div>
			)}
			{renderItemCards()}
		</div>
	);
}

export default LiveQuote;
